export default __webpack_public_path__ + "static/media/platziExchangeImg_2.7fe082f4.png";